import React from "react"

import {ImportList} from "components/backoffice/Transcode/Import/List/ImportList"

export const ImportListRoute = (props: any) => {

  return <div>
    <ImportList />
  </div>
}